/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Fine-grained invoice subtype for the new billing system.
 * Used in conjunction with InvoiceType for precise invoice categorization.
 */
export enum SubInvoiceType {
    /**
     * No subtype specified (legacy invoices).
     */
	None = 'None',
    /**
     * Mid-month plan-change revenue invoice; plan-only proration plus prior-plan credit.
     */
	MonthlyProration = 'MonthlyProration',
    /**
     * Monthly revenue invoice for plan + additional users + usage charges.
     */
	MonthlyService = 'MonthlyService',
    /**
     * Annual funding invoice for new annual signup (may include proration lines).
     */
	AnnualPrepaymentStart = 'AnnualPrepaymentStart',
    /**
     * Annual funding invoice for monthly-to-annual conversion (includes prior-plan credit).
     */
	AnnualPrepaymentConversion = 'AnnualPrepaymentConversion',
    /**
     * Annual funding invoice for renewal (no proration).
     */
	AnnualPrepaymentRenewal = 'AnnualPrepaymentRenewal',
    /**
     * Customer/admin-initiated funding invoice for annual upgrades, user increases, or wallet funding.
     */
	ManualAnnualTopUp = 'ManualAnnualTopUp',
    /**
     * System-generated funding invoice before MSI finalizes when user commit and/or wallet funds are insufficient.
     */
	AutomaticAnnualTopUp = 'AutomaticAnnualTopUp',
    /**
     * Invoice created at forced downgrade with downgrade notice and optional revenue reversal.
     */
	ForcedDowngradeAdjustment = 'ForcedDowngradeAdjustment',
    /**
     * Document that increases CreditBalance (cashless credit).
     */
	CashlessCredit = 'CashlessCredit',
    /**
     * Referral-specific credit issuance.
     */
	ReferralCredit = 'ReferralCredit',
    /**
     * Cash refund back to original payment method.
     */
	CashRefund = 'CashRefund',
}
